import React from 'react'
import './coupon.less'
import { List, Switch } from 'antd-mobile'
import { withRouter } from 'react-router'
const Item = List.Item

function Tips(props: any) {
  const { coupon_no, balanceInfo } = props
  const { coupon_count, coupon_list } = props.coupon_info
  if (coupon_list && coupon_list.length !== 0) {
    let text = ''
    if (coupon_count === '0') {
      text = '暂无可用优惠券'
    } else if (coupon_count !== '0' && coupon_no) {
      text = `-${balanceInfo.coupon_fee}`
    } else if (coupon_count !== '0' && !coupon_no) {
      text = `${coupon_count}张可用`
    }
    return (
      <span className="font-7">
        <span className="font_yellow font-7">
          {text}
          &nbsp;
        </span>
        <i className="iconfont icon-next">&#xe60e;</i>
      </span>
    )
  }
  return (
    <span className="font-7">
      <span className="font_yellow"> 无优惠券 &nbsp;</span>
      <i className="iconfont icon-next">&#xe60e;</i>
    </span>
  )
}
@(withRouter as any)
class Coupon extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      checked: false,
    }
  }
  navCouponList = (coupon_info: any) => {
    const { coupon_list } = coupon_info
    const { depot_id, type } = this.props
    if (coupon_list && coupon_list.length !== 0) {
      this.props.history.push({
        pathname: `/fillorder/coupon-list/${type}/${depot_id}`,
      })
    }
  }
  render() {
    const { coupon_info, coupon_no, balanceInfo, is_distribute } = this.props
    return (
      <div className="goods-coupon">
        <p className="title font-7">支付优惠</p>
        <List className="product-list">
          <Item
            extra={
              <Tips
                coupon_info={coupon_info}
                coupon_no={coupon_no}
                balanceInfo={balanceInfo}
              />
            }
            onClick={() => {
              this.navCouponList(coupon_info)
            }}
          >
            <span className="font-7">优惠券</span>
          </Item>
          <Item
            extra={
              <Switch
                checked={this.props.use_integral}
                onChange={() => {
                  this.props.integralChange()
                }}
              />
            }
          >
            <span className="font-7">
              可用积分抵扣{balanceInfo.integral_money}元
            </span>
          </Item>
          <Item
            extra={<span className="font-7">￥{balanceInfo.total_fee}</span>}
          >
            <span className="font-7">商品实付</span>
          </Item>
          {is_distribute && (
            <Item
              extra={
                <span className="font-7 font_yellow">
                  - ￥{balanceInfo.transport_fee}
                </span>
              }
            >
              <span className="font-7">
                配送费
                <span className="font_yellow font-7">
                  {balanceInfo.transport_text}
                </span>
              </span>
            </Item>
          )}

          <Item
            extra={
              <span className="font-7 font_yellow">
                - ￥{balanceInfo.integral_fee}
              </span>
            }
          >
            <span className="font-7">积分抵扣</span>
          </Item>
          <Item
            extra={
              <p>
                合计{' '}
                <span className="font-7 font_yellow">
                  ￥{balanceInfo.pay_fee}
                </span>
              </p>
            }
          >
            <span> {/** 总计*/}</span>
          </Item>
        </List>
      </div>
    )
  }
}
export default Coupon
